let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iSmBG")).then(() => parcelRequire('3qoCN'));